import { Component, OnInit, Inject, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { NgxPrintModule, NgxPrintService } from 'ngx-print';
import { ActivationService } from "../../../services/activation.service";
import { NgFor, NgIf } from "@angular/common";
import { TranslocoModule } from "@jsverse/transloco";
import { PrintRegistrationKeyComponent } from "../../liat-activation-form/print-registration-key/print-registration-key.component";

@Component({
    selector: 'dl-key-generation-modal',
    templateUrl: './key-generation-modal.component.html',
    styleUrls: ['./key-generation-modal.component.scss'],
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [NgxPrintService],
    imports: [NgIf, NgFor, TranslocoModule, NgxPrintModule, PrintRegistrationKeyComponent ]
})

export class KeyGenerationModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private ngxService: NgxPrintService,
    private activationService: ActivationService, private dialog: MatDialog) { }

  public displayedColumns: string[] = ['regKey', 'token', 'barcode'];
  public dataSource = [];
  regKeys = [];
  selection = new SelectionModel<any>(true, []);
  keyGenerationTitle = 'Key generation is successful for valid keys.';
  keyGenerationStatus = 'Success';



  ngOnInit(): void {
    this.dataSource = this.data;
    this.keyGenerationTitle = `Key generation is successful for valid keys.`;
    this.keyGenerationStatus = `Success`;
  }

  public printPage(): void {
    const customPrintOptions = {
      printSectionId: 'print-section',
      printTitle: "Liat Key Activation",
      useExistingCss: true,
      bodyClass: '',
      openNewTab: false,
      previewOnly: false,
      closeWindow: true,
      printDelay: 0
    };
    this.ngxService.print(customPrintOptions);
  }

  public closePopup(): void {
    this.dialog.closeAll();
  }

  public selectHandler(row: any) {
    if (!this.selection.isSelected(row)) {
      this.selection.clear();
    }
    this.selection.toggle(row);
  }

}